import { StringBase } from '../StringBase';

export class SpecificPublisher extends StringBase {}
